const UNSAFE_SCHEME_PATTERN = /^[a-z][a-z0-9+.-]*:/i;
const HTTP_SCHEME_PATTERN = /^https?:\/\//i;

/**
 * Returns redirectTo when it resolves to a same-origin in-app path; otherwise undefined.
 * Rejects external URLs, protocol-relative paths, and javascript/data URLs.
 */
export function getSafeRedirectPath(redirectTo: string | undefined | null): string | undefined {
  if (!redirectTo) {
    return undefined;
  }

  const trimmed = redirectTo.trim();
  if (!trimmed) {
    return undefined;
  }

  if (trimmed.startsWith("//") || trimmed.startsWith("\\") || trimmed.includes("\\")) {
    return undefined;
  }

  const resolvedOrigin = window.location.origin;

  try {
    let resolved: URL;
    if (UNSAFE_SCHEME_PATTERN.test(trimmed)) {
      if (!HTTP_SCHEME_PATTERN.test(trimmed)) {
        return undefined;
      }

      resolved = new URL(trimmed);
    } else {
      if (!trimmed.startsWith("/")) {
        return undefined;
      }

      resolved = new URL(trimmed, resolvedOrigin);
    }

    if (resolved.origin !== resolvedOrigin) {
      return undefined;
    }

    return `${resolved.pathname}${resolved.search}${resolved.hash}`;
  } catch {
    return undefined;
  }
}
